import { Navbar, MediaQuery, ScrollArea } from "@mantine/core";
import { LinksGroup, ILinksGroupProps } from "../layout/sidenav/NavbarLinks";
import { IconHelp, IconPhone } from "@tabler/icons-react";

const data: ILinksGroupProps[] = [
  {
    icon: IconHelp,
    label: "Help",
    route: "https://sellerhelp.woolworthsmarketplus.com.au/hc/en-gb",
  },
  {
    icon: IconPhone,
    label: "Contact",
    route: "/seller-application",
  },
];

export const NavMenu = ({ opened }: { opened: boolean }) => {
  const links = data.map((item) => <LinksGroup {...item} key={item.label} />);
  return (
    <MediaQuery largerThan="sm" styles={{ display: "none" }}>
      <Navbar width={{ base: 300 }} p="md" hidden={!opened} data-testid="landing-navbar">
        <Navbar.Section grow mt="xs" component={ScrollArea}>
          {links}
        </Navbar.Section>
      </Navbar>
    </MediaQuery>
  );
};
